import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=507d9016&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=ts&setup=true"
export * from "./Terms.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Terms.vue?vue&type=style&index=0&id=507d9016&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507d9016",
  null
  
)

export default component.exports